import { queryFor } from "@visioni/a3s-client-api/app";
import { accessManagementEndpoint, usersSearchEndpoint } from "../client-messages/role-assignments";
import { myPermissionsEndpoint } from "../client-messages/my-permissions";

export const accessManagementQuery = queryFor(accessManagementEndpoint);
export const usersSearchQuery = queryFor(usersSearchEndpoint);
export const myPermissionsQuery = queryFor(myPermissionsEndpoint);
